<template>
  <div class="component-card">
    <j-title-header :options="title"/>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */

export default {
  components: {
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Dashboard Bimbingan Konseling',
        opt_title: 'Administrator',
      },
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/jDashBK.vue